class Dropdown {
  constructor({ el, activeOption, onChange }) {
    this.el = el;
    this.optionsContainer = this.el.querySelector('[data-options]');
    this.options = Array.from(this.optionsContainer.children);
    this.onChange = onChange;
    this.currentOption = this.el.querySelector('[data-current-option]');
    this.activeOption = activeOption;
    this.toggle = this.toggle.bind(this);
    this.init();
  }

  init() {
    this.el.addEventListener('click', this.toggle);
    this.options.forEach((option) => {
      option.addEventListener('click', () => {
        this.activeOption = option.dataset.id;
        this.setActiveOption();
        this.onChange(option);
        this.resetActiveOption(option);
      });
    });
    this.setActiveOption();
  }

  toggle() {
    this.el.classList.toggle('js--active');
  }

  setActiveOption() {
    if (this.activeOption) {
      const target = this.el.querySelector(`[data-id="${this.activeOption}"]`);
      this.currentOption.innerText = target.innerText;
      const activeOption = this.optionsContainer.querySelector(
        '[data-current-option].active'
      );
      this.resetActiveOption(activeOption);
      target.classList.add('active');
    }
  }

  resetActiveOption(option) {
    this.options.forEach((opt) => {
      if (opt !== option) {
        opt.classList.remove('active');
      }
    });
  }
}

export default Dropdown;
